"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.user = exports.auto = void 0;
// biome-ignore lint: -
exports.auto = require("../../../../assets/images/auto.png");
// biome-ignore lint: -
exports.user = require("../../../../assets/images/user.png");
//# sourceMappingURL=value-sources.js.map